import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute, notFound, Outlet, useLocation } from "@tanstack/react-router";

import { LinkNotFound } from "~/components/registration/link-not-found";
import { RegistrationFrame } from "~/components/registration/registration-frame";
import { ApiError } from "~/lib/api";
import { enrollCodeQueryOptions } from "~/lib/api/enroll";

function stepOf(pathname: string): number {
  return pathname.endsWith("/gegevens") ? 1 : 0;
}

export const Route = createFileRoute("/(public)/aanmelden/$enrollCode")({
  loader: async ({ context, params }) => {
    try {
      await context.queryClient.query(enrollCodeQueryOptions(params.enrollCode));
    } catch (error) {
      if (error instanceof ApiError && error.status === 404) throw notFound();
      throw error;
    }
  },
  notFoundComponent: LinkNotFound,
  component: EnrollLayout,
});

function EnrollLayout() {
  const { enrollCode } = Route.useParams();
  const { data: parent } = useSuspenseQuery(enrollCodeQueryOptions(enrollCode));
  const step = useLocation({ select: (location) => stepOf(location.pathname) });

  return (
    <RegistrationFrame parentName={parent.companyName} step={step}>
      <Outlet />
    </RegistrationFrame>
  );
}
